import { ExtendedAttributeType } from 'app/library/extended-attributes/enums/extended-attribute-type.enum';
import * as moment from 'moment';
import { IModuleExtendedAttribute } from '../interfaces/module-extended-attribute.interface';

export class ModuleExtendedAttributeCommand {
    module: {
        id: number;
    };
    values: {
        extended_attribute: {
            id: number;
        };
        value_number: number;
        value_text: string;
        value_date: Date;
        value_address: {
            street_name: string;
            street_number: string;
            zip_code: string;
            city: string;
            country: string;
        };
    }[];

    constructor(payload: IModuleExtendedAttribute) {
        this.module = {
            id: parseInt(payload.moduleId),
        };
        this.values = payload.values.map((value) => {
            return {
                extended_attribute: {
                    id: parseInt(value.extendedAttribute.id),
                },
                value_number: value.extendedAttribute.type === ExtendedAttributeType.Number ? (value.value as number) : null,
                value_text: value.extendedAttribute.type === ExtendedAttributeType.Text ? (value.value as string) : null,
                value_date:
                    value.extendedAttribute.type === ExtendedAttributeType.Date ? (value.value ? new Date(moment(value.value)?.format('YYYY-MM-DD')) : (value.value as any)) : null,
                value_address:
                    value.extendedAttribute.type === ExtendedAttributeType.Address
                        ? {
                              street_name: value.valueAddress?.streetName || null,
                              street_number: value.valueAddress?.streetNumber?.toString() || null,
                              zip_code: value.valueAddress?.zipCode?.toString() || null,
                              city: value.valueAddress?.city || null,
                              country: value.valueAddress?.country || null,
                          }
                        : null,
            };
        });
    }
}
